export interface ErrorWithCause {
  cause?: {
    error?: string;
  };
  message?: string;
}

const isErrorWithCause = (error: unknown): error is ErrorWithCause => {
  return error !== null && typeof error === 'object';
};
export default isErrorWithCause;